import { useContext, useState } from 'react'

import { Button, Grid, Hidden, InputAdornment, Tooltip } from '@material-ui/core'
import TextFieldMaterial from '@material-ui/core/TextField'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import PrintIcon from '@material-ui/icons/Print'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { EditContext } from 'Components/Hooks/ContextEdit'
import { FormContext } from 'Components/Hooks/ContextForm'
import Loader from 'Components/UI/Atoms/Loader'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import { Field, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { printPDF } from 'Helpers'
import { interfaces } from 'service/interfaces'

import CostsAndExpenses from './Modals'
import useStyles from './styles'

const Quotation = () => {
  const classes = useStyles()

  const createDismissableSnackbar = useCustomSnackbar()

  const [wait, setWait] = useState(false)

  const [edit] = useContext(EditContext)

  const { formEdit, setFormEdit, setFormApi, formApi, initialData } = useContext(FormContext)

  const getFactor = () => {
    const iva = 0.21
    const percepciones = formEdit.vehicle.cia_seguros.percepciones

    const totalPerc = percepciones.reduce((acc, p) => acc + (Number(p.value) || 0) / 100, 0)

    return 1 + iva + totalPerc
  }

  const DATA_FORM = formEdit.hasOwnProperty('vehicle')
    ? {
        ...formEdit.vehicle.vehiculo_cotizacion,

        cotizacion_siniestro: formEdit.vehicle.vehiculo_cotizacion?.cotizacion_restos
          ? (
              parseFloat(formEdit.vehicle.vehiculo_cotizacion.cotizacion_restos) /
              getFactor('cotizacion_restos')
            ).toFixed(2)
          : '',

        cotizacion_retiro_neto: formEdit.vehicle.vehiculo_cotizacion?.cotizacion_retiro
          ? (parseFloat(formEdit.vehicle.vehiculo_cotizacion.cotizacion_retiro) / 1.21).toFixed(2)
          : '',

        cotizacion_retiro:
          !formEdit.vehicle.vehiculo_cotizacion?.cotizacion_retiro &&
          formEdit.vehicle.vehiculo_cotizacion?.cotizacion_retiro_neto
            ? (
                parseFloat(formEdit.vehicle.vehiculo_cotizacion.cotizacion_retiro_neto) * 1.21
              ).toFixed(2)
            : formEdit.vehicle.vehiculo_cotizacion?.cotizacion_retiro || '',
      }
    : {}

  const [form, setForm] = useState(DATA_FORM)

  const formatForDisplay = (value) => {
    if (value === null || value === '' || isNaN(value)) return ''
    const num = parseFloat(value)
    const rounded = Math.round(num * 100) / 100
    return Number.isInteger(rounded) ? rounded.toString() : rounded.toFixed(2)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    let newForm = { ...form }
    const factor = getFactor(name)

    if (name === 'cotizacion_restos') {
      if (value === '' || value == null) {
        newForm.cotizacion_restos = ''
        newForm.cotizacion_siniestro = ''
      } else {
        const conIVA = parseFloat(value)
        const neto = conIVA / factor
        newForm.cotizacion_restos = value
        newForm.cotizacion_siniestro = formatForDisplay(neto)
      }
    } else if (name === 'cotizacion_siniestro') {
      if (value === '' || value == null) {
        newForm.cotizacion_siniestro = ''
        newForm.cotizacion_restos = ''
      } else {
        const neto = parseFloat(value)
        const conIVA = neto * factor
        newForm.cotizacion_siniestro = value
        newForm.cotizacion_restos = formatForDisplay(conIVA)
      }
    } else if (name === 'cotizacion_retiro') {
      if (value === '' || value == null) {
        newForm.cotizacion_retiro = ''
        newForm.cotizacion_retiro_neto = ''
      } else {
        const conIVA = parseFloat(value)
        const neto = conIVA / 1.21
        newForm.cotizacion_retiro = value
        newForm.cotizacion_retiro_neto = formatForDisplay(neto)
      }
    } else if (name === 'cotizacion_retiro_neto') {
      if (value === '' || value == null) {
        newForm.cotizacion_retiro_neto = ''
        newForm.cotizacion_retiro = ''
      } else {
        const neto = parseFloat(value)
        const conIVA = neto * 1.21
        newForm.cotizacion_retiro_neto = value
        newForm.cotizacion_retiro = formatForDisplay(conIVA)
      }
    } else {
      newForm[name] = value
    }

    setForm(newForm)

    const {
      cotizacion_siniestro: _cotizacion_siniestro,
      cotizacion_retiro_neto: _cotizacion_retiro_neto,
      ...formForBackend
    } = newForm

    setFormEdit({
      ...formEdit,
      vehicle: {
        ...formEdit.vehicle,
        vehiculo_cotizacion: {
          ...formForBackend,
        },
      },
    })

    setFormApi({
      ...formApi,
      vehiculo_cotizacion: {
        ...formForBackend,
      },
    })
  }

  const handleBlur = (e) => {
    const { name, value } = e.target

    if (name === 'observaciones') {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }))
      return
    }

    if (!value) return

    let newForm = { ...form }
    const num = parseFloat(value) || 0
    const rounded = Math.round(num * 100) / 100
    newForm[name] = Number.isInteger(rounded) ? rounded.toString() : rounded.toFixed(2)
    setForm(newForm)
  }

  async function print() {
    setWait(true)
    await interfaces.vehicleInterface
      .vehicleOffer(formEdit.vehicle.id)
      .then((res) => printPDF(res, 1000, 700))
      .catch((_error) => {
        createDismissableSnackbar('Algo salió mal!', {
          variant: 'error',
        })
      })
    setWait(false)
  }

  const displayValue = (value) => {
    return value === '0.00' || value === null ? '' : value
  }

  const disabledField = () => {
    if (initialData.header.authorization === 1 && edit) {
      return true
    }
    if (initialData.header.authorization === 1 && !edit) {
      return true
    } else return edit ? false : true
  }

  const objeto = [
    {
      id: 1,
      label: 'Cotización restos (imp. incluidos)',
      name: 'cotizacion_restos',
      sm: 6,
      xs: 12,
      value: displayValue(form.cotizacion_restos),
      select: false,
      disabled: disabledField(),
      icon: <AttachMoneyIcon />,
    },
    {
      id: 2,
      label: 'Cotización restos (neto)',
      name: 'cotizacion_siniestro',
      sm: 6,
      xs: 12,
      value: form.cotizacion_siniestro ?? '',
      select: false,
      disabled: disabledField(),
      icon: <AttachMoneyIcon />,
    },
    {
      id: 3,
      label: 'Cotización retiro (IVA incluido)',
      name: 'cotizacion_retiro',
      sm: 6,
      xs: 12,
      value: displayValue(form.cotizacion_retiro),
      select: false,
      disabled: disabledField(),
      icon: <AttachMoneyIcon />,
    },
    {
      id: 4,
      label: 'Cotización retiro (neto)',
      name: 'cotizacion_retiro_neto',
      sm: 6,
      xs: 12,
      value: form.cotizacion_retiro_neto || '',
      select: false,
      disabled: disabledField(),
      icon: <AttachMoneyIcon />,
    },
    {
      id: 5,
      label: 'Estado',
      name: 'cotizacion_retiro',
      sm: 12,
      xs: 12,
      value: form.estado_retiro,
      disabled: true,
      icon: <AttachMoneyIcon />,
      select: true,
      options: [
        {
          id: 1,
          label: 'Retiro pendiente',
        },
        {
          id: 2,
          label: 'Retiro en curso',
        },
        {
          id: 3,
          label: 'Retiro realizado',
        },
      ],
    },
    {
      id: 6,
      label: 'Observaciones',
      name: 'observaciones',
      sm: 12,
      xs: 12,
      value: form.observaciones,
      disabled: disabledField(),
      multiline: true,
      rows: 5,
    },
  ]

  return (
    <div className={classes.rootGrid}>
      <Formik initialValues={form}>
        <Grid
          container
          spacing={2}
          justify="center"
          alignItems="center"
          className={classes.paddingGrids}
        >
          {objeto.map((item) => (
            <Grid item sm={item.sm} xs={item.xs}>
              {item.select ? (
                <Autocomplete
                  disabled={item.disabled}
                  noOptionsText="No se encontraron resultados"
                  getOptionLabel={(option) => option.label}
                  options={item.options}
                  defaultValue={item.options.find(
                    (status) => status.id === parseInt(form.estado_retiro)
                  )}
                  renderInput={(params) => (
                    <TextFieldMaterial
                      {...params}
                      fullWidth
                      label={item.label}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              ) : (
                <Field
                  component={TextField}
                  disabled={item.disabled}
                  fullWidth
                  variant="outlined"
                  type={item.type}
                  name={item.name}
                  label={item.label}
                  multiline={item.multiline}
                  rows={item.rows}
                  value={item.uppercase ? item.value.toUpperCase() : item.value}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: <InputAdornment>{item.icon}</InputAdornment>,
                  }}
                />
              )}
            </Grid>
          ))}

          <Grid container justify="flex-end" item xs={12} sm={12} spacing={1}>
            <Tooltip title="Debe guardar los cambios antes de presionar este botón">
              <Hidden xsDown>
                <Button
                  className={classes.styleButtons}
                  variant="contained"
                  endIcon={<PrintIcon />}
                  disabled={disabledField()}
                  onClick={print}
                >
                  IMPRIMIR
                </Button>
              </Hidden>
            </Tooltip>

            <CostsAndExpenses disabled={disabledField()} />
          </Grid>
        </Grid>
      </Formik>
      {wait ? <Loader /> : null}
    </div>
  )
}

export default Quotation
